import { Link } from "react-router-dom";
import "../Styles/Footer.css";

export const Footer = () => {
  return (
    <footer>
      <div className="footer-container">
        <hr className="footer-divider" />
        <div className="footer-bottom">
          <div className="augio-copyright">© Augio 2026</div>
          <div className="footer-links">
            <Link to="/terms" className="footer-link">
              Terms
            </Link>
            <span className="footer-separator">|</span>
            <Link to="/privacy" className="footer-link">
              Privacy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
